<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2022-01-28 22:50:30
 * @LastEditTime: 2023-05-29 15:03:55
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <div class="logo">
        <router-link :to="url">
            <img class="logo-light" :src="lightLogo" alt="Corporate Logo"/>
            <img class="logo-dark" :src="darkLogo" alt="Corporate Logo"/>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'Logo',
        props: {
            url: {
                type: String,
                default: ''
            },
            lightLogo: {
                type: String,
                default: function () {
                    return require(`@/assets/images/logo/logo.png`)
                }
            },
            darkLogo: {
                type: String,
                default: function () {
                    return require(`@/assets/images/logo/logo-dark.png`)
                }
            }
        }
    }
</script>